"use client"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Search, Phone, User, FileText,Calendar, BadgeCheck,MapPin   } from "lucide-react"
import { useAuth } from "../../contexts/AuthContext"
import axios from "axios"
import { useMemo } from "react";


interface Customer { 
  CorpName:string
  StoreName:string
  FirstName:string
  LastName:string
  CustomerID:number
  PONumber:string
  POSchdeuleDate:string
  POWaiver:boolean
  POTypeDisplayName:string
  CustPhoneHome:string
  CustAddress:string
  POStatus:string
  MATType:string
}
interface POEntry {
  poNumber: string;
  scheduleDate: string;
  jobType: string;
  status: string;
  waiver: boolean;
  matType: string;
}

interface CustomerGroup {
  customerId: number;
  name: string;
  phone: string;
  address: string;
  poList: POEntry[];
}


export default function CustomerSearch() {
  const navigate = useNavigate()
  const [searchType, setSearchType] = useState<"phone" | "name" | "po">("phone")
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResults, setSearchResults] = useState<Customer[]>([])
  const [isSearching, setIsSearching] = useState(false)
  const { user } = useAuth()

  const customerScResult = async (phone:string, name:string,poNumber:string): Promise<boolean> => {
        //const response = await axios.get("https://qaacsstoreapi.acsouth.com:443/api/searchcustinfo?storeId="+ user?.Store +"&vpo="+ poNumber +"&vcust="+name+"&vphone=" + phone)
        //const response = await axios.get("https://devprodapi.acsouth.com:443/api/searchcustinfo?storeId="+ user?.Store +"&vpo="+ poNumber +"&vcust="+name+"&vphone=" + phone)
        //PRODUCTION
        const response = await axios.get("https://acsstoreapi.acsouth.com:443/api/searchcustinfo?storeId="+ user?.Store +"&vpo="+ poNumber +"&vcust="+name+"&vphone=" + phone)
       debugger;
        const data = response.data
        debugger;
        if (Array.isArray(data) && data.length > 0) {
        setSearchResults(data);
        return true;
      } else {
        setSearchResults([]);
        return false;
      } 
  }
      
  const customerEntries = useMemo(() => {
  const grouped: Record<number, CustomerGroup> = searchResults.reduce((acc, item) => {
    const customerId = item.CustomerID;
    if (!acc[customerId]) {
      acc[customerId] = {
        customerId: item.CustomerID,
        name: `${item.FirstName} ${item.LastName}`,
        phone: item.CustPhoneHome,
        address: item.CustAddress,
        poList: [],
      };
    }
    acc[customerId].poList.push({
      poNumber: item.PONumber,
      scheduleDate: item.POSchdeuleDate,
      jobType: item.POTypeDisplayName,
      matType:item.MATType,
      status: item.POStatus,
      waiver: item.POWaiver,
    });
    return acc;
  }, {} as Record<number, CustomerGroup>);
  
  return Object.values(grouped);
}, [searchResults]);

debugger;
  
  const handleSearch = async () => {
    if (!searchTerm.trim()) return
    
    setIsSearching(true)

 try {
     // Determine search parameters based on searchType
    let phone = ""
    let name = ""
    let poNumber = ""

    switch (searchType) {
      case "phone":
        phone = searchTerm
        break
      case "name":
        name = searchTerm
        break
      case "po":
        poNumber = searchTerm
        break
    }


    // Call the   API
    const success = await customerScResult(phone, name, poNumber)

    if (!success) {
      setSearchResults([]) // optional: clear results or show "not found"
    }
 
   } catch (error) {
    console.error("Search error:", error)
    setSearchResults([]) // optional: handle error UI
  } finally {
    setIsSearching(false)
  }
  }

  const handleCustomerClick = (customerId: number) => {
    navigate(`/dashboard/customer-details/${customerId}`)
  }

  return (
    <div className="p-4 lg:p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-6">Customer Search</h1>

        {/* Search Form */}
        <div className="bg-white rounded-lg shadow-md p-4 lg:p-6 mb-6">
          <div className="space-y-4">
            {/* Search Type Selection */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Search By:</label>
              <div className="flex flex-wrap gap-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="searchType"
                    value="phone"
                    checked={searchType === "phone"}
                    onChange={(e) => setSearchType(e.target.value as "phone")}
                    className="mr-2"
                  />
                  <Phone className="h-4 w-4 mr-1" />
                  Phone Number
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="searchType"
                    value="name"
                    checked={searchType === "name"}
                    onChange={(e) => setSearchType(e.target.value as "name")}
                    className="mr-2"
                  />
                  <User className="h-4 w-4 mr-1" />
                  Customer Last Name
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="searchType"
                    value="po"
                    checked={searchType === "po"}
                    onChange={(e) => setSearchType(e.target.value as "po")}
                    className="mr-2"
                  />
                  <FileText className="h-4 w-4 mr-1" />
                  PO Number
                </label>
              </div>
            </div>

            {/* Search Input */}
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="flex-1">
                <input
                  type="text"
                  placeholder={`Enter ${searchType === "phone" ? "phone number" : searchType === "name" ? "customer name" : "PO number"}...`}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                />
              </div>
              <button
                onClick={handleSearch}
                disabled={isSearching || !searchTerm.trim()}
                className="flex items-center justify-center px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                <Search className="h-4 w-4 mr-2" />
                {isSearching ? "Searching..." : "Search"}
              </button>
            </div>
          </div>
        </div>

        {/* Search Results */}
        {searchResults.length > 0 && (
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="px-4 lg:px-6 py-4 border-b">
              <h2 className="text-lg font-semibold text-gray-900">Search Results ({searchResults.length} found)</h2>
            </div>
            <div className="divide-y divide-gray-200">
                {customerEntries.map((customer) => (
                  <div
                        key={customer.customerId}
                        onClick={() => handleCustomerClick(customer.customerId)}
                        className="p-4 lg:p-6 hover:bg-gray-50 cursor-pointer transition-colors"
                      >
                       {/* First Line: Customer Info */}
                      <div className="text-base font-semibold text-blue-700 mb-1 flex flex-col lg:flex-row lg:justify-between lg:items-center">
                        {/* Left: Customer Name with Icon */}
                        <div className="flex items-center">
                          <User className="h-4 w-4 mr-2" />
                          <span>{customer.name}</span>
                        </div>

                        {/* Right: Phone + Address */}
                        <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm text-gray-600 mt-1 lg:mt-0">
                          <div className="flex items-center">
                            <Phone className="h-4 w-4 mr-1 text-gray-500" />
                          {formatPhoneNumber( customer.phone)}
                          </div>
                          <div className="flex items-center">
                            <MapPin className="h-4 w-4 mr-1 text-gray-500" />
                            {customer.address}
                          </div>
                        </div>
                      </div>
 
                    {/* Second Line: PO Table */}
                    <div className="text-sm mt-4 space-y-2">
                          {customer.poList.map((po, index) => (
                            <div
                              key={index}
                              className="grid grid-cols-1 md:grid-cols-4 gap-x-6 items-center border-b border-gray-200 py-2 px-2 hover:bg-gray-50 rounded transition"
                            >
                              {/* PO Number */}
                              <div className="flex items-center text-blue-700 font-medium">
                                <FileText className="h-4 w-4 mr-1 text-blue-500" />
                                <span className="truncate">{po.poNumber}</span>
                              </div>

                              {/* Job Type */}
                              <div className="flex items-center text-gray-700">
                                <BadgeCheck className="h-4 w-4 mr-1 text-gray-500" />
                                <span className="font-medium mr-1">Job Type:</span>
                                <span className="truncate">{po.matType} </span>
                              </div>

                              {/* Schedule Date */}
                              <div className="flex items-center text-gray-700">
                                <Calendar className="h-4 w-4 mr-1 text-gray-500" />
                                <span className="font-medium mr-1">Schedule:</span>
                                <span>{ !po.scheduleDate || isNaN(new Date(po.scheduleDate).getTime()) 
                                  ? "Not Scheduled" 
                                  : new Date(po.scheduleDate).toLocaleDateString("en-US", { 
                                      year: "numeric", 
                                      month: "2-digit", 
                                      day: "2-digit" 
                                    })
                              }</span>
                              </div>

                              {/* Status */}
                              <div className="flex items-center text-gray-700">
                                {/* <span className="font-medium mr-2">Status:</span> */}
                                <span
                                  className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                                    po.status === "Paid"
                                      ? "bg-green-100 text-green-800"
                                      : po.status === "To be paid"
                                      ? "bg-yellow-100 text-yellow-800"
                                      : po.status === "Cancelled"
                                      ? "bg-red-100 text-red-800"
                                      : "bg-blue-100 text-blue-800"
                                  }`}
                                >
                                  {po.status}
                                </span>
                              </div>
                            </div>
                          ))}
                      </div> 
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* No Results */}
        {searchResults.length === 0 && searchTerm && !isSearching && (
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <Search className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No customers found</h3>
            <p className="text-gray-600">Try searching with different criteria or check your spelling.</p>
          </div>
        )}
      </div>
    </div>
  )
}

function formatPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, ""); // remove non-digits
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phone; // fallback if not 10 digits
}